<template>
	<div class="app-switch" :class="switchClasses" @click="$emit('change', isTrue ? falseValue : trueValue)">
		<span class="app-switch-toggle" :class="isTrue ? 'app-switch-true' : 'app-switch-false'" />
		<span class="app-switch-label" :class="isTrue ? 'app-switch-true' : 'app-switch-false'">
			{{ isTrue ? onLabel : offLabel }}
		</span>
	</div>
</template>

<script>
	export default {
		name: 'AppSwitch',
		emits: ['change'],
		props: {
			modelValue: {
				required: true,
			},
			falseValue: {
				type: [String, Number, Boolean],
				default: 0,
			},
			trueValue: {
				type: [String, Number, Boolean],
				default: 1,
			},
			offLabel: {
				type: [String, Object],
				required: false,
				default: 'Hidden',
			},
			onLabel: {
				type: [String, Object],
				required: false,
				default: 'Active',
			},
			disabled: {
				type: Boolean,
				default: false,
			},
		},
		computed: {
			isTrue() {
				return this.modelValue === this.trueValue;
			},
			switchClasses() {
				const classes = [];
				if (this.isTrue) {
					classes.push('app-switch-true');
				} else {
					classes.push('app-switch-false');
				}
				if (this.disabled) {
					classes.push('cursor-not-allowed');
				}
				return classes.join(' ');
			},
		},
	};
</script>
